import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
// import { AzureBlobStorageService } from "../core/_services/azure-blob-storage.service";
import { RouteChangeConfirmationComponent } from "./components/route-change-confirmation/route-change-confirmation.component";

@Injectable()
export class sharedService {

  constructor(
    private dialog: MatDialog
  ) {
  }

  openRouteConfirmation() {
    const dialogRef = this.dialog.open(RouteChangeConfirmationComponent, {
      maxHeight: "100%",
      maxWidth: "100%",
      disableClose: true,
      hasBackdrop: true
    });
    const result = dialogRef.afterClosed().toPromise();
    return result;
  }
}
